<template>
	<div :class="isMe ? 'chat__outgoing-message' : 'chat__incoming-message'" v-intersect="intersect" >
		<div v-if="!isMe" class="avatar-wrapper mr-1">
				<avatar :user="message.user" />
			</div>
		<div class="message-body-container">
			<span v-if="!isMe" class="bold">{{ message.user.name }}</span>
			<span v-else class="bold">Ty</span>
			<span class="timestamp ml-2" :key="listKey">{{ $moment(message.created_at).fromNow() }}</span>
			<div class="message-body mt-2">
				<div v-if='!edit && isMe' class="message-action-container">
					<post-dropdown :options="validOptions" small/>
				</div>
				<div v-if="!edit && (message.created_at != message.updated_at)" class="edited-container">
					<v-icon size="10px">mdi-pencil</v-icon> Edytowano
				</div>
				<div v-if="edit">
					<content-editable-input
						@input="onInput"
						v-model="fields.content"
						:key="inputKey"
						emojis
						@escapePress="escapePress"
						@enterPress="save()"
						ref="content-editable-input"
						style="min-height: 80px"
						:chat-room-users="users"
						:placeholder="$vuetify.lang.t('$vuetify.views.wall.addNewPost.startTyping')"
						class="post-comment-add-input d-flex flex-grow-1 font-12 rounded px-2"
					/>
					<div class="text-right mt-2">
						<v-btn @click="edit = false" class="mr-1">Anuluj</v-btn>
						<v-btn @click="save()" :disabled="!fields.content.content" :loading="saving" color="accent"><v-icon>mdi-check</v-icon> Zapisz</v-btn>
					</div>
				</div>
				<multicontent v-else-if="message.content" :content="message.content" :mentions="message.mention_users" url-preview class="mt-2"/>
				<div v-if="message.images.length == 1" class="chat-message-image mt-3">
					<div class="actions">
						<v-btn @click="deleteImage(message.images[0])" icon outlined class="white" small><v-icon>mdi-close</v-icon></v-btn>
					</div>
					<v-img
						:src="message.images[0].url"
						aspect-ratio="1"
						lazy-src="@/assets/images/image-placeholder.jpg"
						@click="previewImage(message.images[0])"
						class="rounded link"
					/>
				</div>
				<v-row v-else-if="message.images.length > 1" class="pa-2 mt-3">
					<v-col v-for="image in message.images" :key="image.id" cols="4" class="pa-1">
						<div class="chat-message-image">
							<div class="actions">
								<v-btn
									v-if="isMe"
									@click="deleteImage(image)"
									icon
									outlined
									class="white"
									x-small><v-icon>mdi-close</v-icon></v-btn>
							</div>
							<v-img
								:src="image.url"
								aspect-ratio="1"
								lazy-src="@/assets/images/image-placeholder.jpg"
								@click="previewImage(image)"
								class="rounded link"
								/>
							</div>
					</v-col>
				</v-row>
				<div v-if="message.attachments.length" class="mt-3 d-flex flex-wrap align-items-center">
					<div
						v-for="attachment in message.attachments"
						:key="attachment.id"
						class="pr-1 pb-1"
						>
						<v-tooltip
							:disabled="trimmed(attachment.original_name) == attachment.original_name"
							top
							:open-delay="500"
							>
							<template v-slot:activator="{ on }">
								<v-btn
									v-on="on"
									small
									:href="attachment.url_download"
									class="mr-1"
								><v-icon class="mr-1">mdi-attachment</v-icon>{{ trimmed(attachment.original_name) }}</v-btn>
							</template>
							{{ attachment.original_name }}
						</v-tooltip>
						<v-btn
							v-if="isMe"
							@click="deleteAttachment(attachment)"
							icon
							outlined
							x-small
							class="pa-0 mt-1"
							><v-icon>mdi-close</v-icon></v-btn>
					</div>
				</div>
			</div>
			<div class="d-flex flex-wrap align-items-center">
			<post-reaction-icons :message="message" :key="reactionsKey" class="ml-1 mr-2" />
			<v-btn
				@click="react()"
				depressed
				plain
				:id="'message-reaction-button-' + _uid"
				:class="reactionData.color"
				class="px-0"
				@mouseenter.native="$refs['message-reaction-buttons'].show()"
				@mouseleave.native="$refs['message-reaction-buttons'].hide()"
			>
				<v-icon class="mr-1">{{ reactionData.icon }}</v-icon> {{ reactionData.text }}</v-btn>
				<post-reaction-add
					:ref="'message-reaction-buttons'"
					:attach="'message-reaction-button-' + _uid"
					:message="message" />
				<div v-if="isMe" class="delivery-status ml-auto">
					<template>
						<div v-for="(u, index) in readBy" :key="index">
							<div v-if="u.user && u.user.id != user.id">
								<avatar :user="u.user" xxs  />
							</div>
						</div>
					</template>
					<template >
						<!--
						<div v-if="isReadByUser(otherUser.id)">
							<v-tooltip top :open-delay="500">
								<template v-slot:activator="{ on }">
									<div v-on="on" class="font-10">
										<v-icon size="12">mdi-checkbox-marked-circle-outline</v-icon> Wyświetlono
									</div>

								</template>
								{{ isReadByUser(otherUser.id) }}
							</v-tooltip>
						</div>
						<div v-else>
							<v-tooltip top :open-delay="500">
								<template v-slot:activator="{ on }">
									<div v-on="on">
										<v-icon size="12">mdi-check-circle-outline</v-icon>
									</div>

								</template>
								Wysłano
							</v-tooltip>
						</div>
						-->
					</template>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar';
import {mapGetters} from 'vuex';
import Multicontent from '@/components/items/Multicontent';
import PostDropdown from '@/components/wall/post/PostDropdown';
import ContentEditableInput from '@/components/items/ContentEditableInput';
import PostReactionAdd from '@/components/wall/post/PostReactionAdd';
import PostReactionIcons from "@/components/wall/post/PostReactionIcons";

export default {
	props: {
		message: {
			type: Object,
		},
		users: {
			type: Array,
			required: true
		},
		isPublic: {
			type: Boolean,
			default: false
		},
		isDirect: {
			type: Boolean,
			default: true
		},
		listKey: {
			type: Number
		}
	},
	components: {
		Avatar,
		Multicontent,
		PostDropdown,
		ContentEditableInput,
		PostReactionAdd,
		PostReactionIcons
	},
	data() {
		return {
			reactionsKey: 0,
			edit: false,
			inputKey: 0,
			fields: {
				content: null
			},
			saving: false,
			options: [
				{
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.edit'),
					icon: '$edit',
					type: 'edit',
					action: async () => {
						this.startEdit();
					},
					me: true
				},
				{
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.delete'),
					icon: '$delete',
					type: 'delete',
					action: async () => {
						this.$emit('startDelete', this.message)
					},
					me: true
				},
			]
		}
	},
	watch: {
		'message.reactions': {
			handler() {
				this.reactionsKey++;
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			user: 'auth/user'
		}),
		reactionData() {
			if(this.message.my_reaction) {
				switch (this.message.my_reaction.type) {
					case 'applause':
						return {
							color: 'blue--text',
							text: 'Polecasz',
							icon: '$applause-reaction',
						}
					case "happy":
						return {
							color: 'gold--text',
							text: 'Polecasz',
							icon: '$face-reaction',
						}
					case "love":
						return {
							color: 'warning--text',
							text: 'Polecasz',
							icon: '$heart-reaction',
						}
					default:
						return {
							color: 'success--text',
							text: 'Polecasz',
							icon: '$like-small',
						}
				}
			}
			return {
				color: 'grey--text',
				text: 'Zareaguj',
				icon: '$like-small',
			}

		},
		validOptions() {
			if(this.isMe) {
				return this.options.filter(x => x.me)
			}
			return this.options.filter(x => !x.me)
		},
		isMe() {
			if(this.message.user.id == this.user.id) {
				return true;
			}
			return false;
		},
		readBy() {
			let arr = [];
			if(this.message.delivery_statuses && this.users.length) {
				this.message.delivery_statuses.forEach(x => {
					if(x.read_at) {
						arr.push({
							user: this.getUser(x.recipient_user_id),
							read_at: x.read_at
						})
					}
				})
			}
			return arr;
		},
		otherUsers() {
			return this.users.filter(x => x.id != this.user.id);
		},
		finalModel() {
			let model = {
				content: this.fields.content?.content,
				mention_user_ids : this.fields.content?.mentions
			};
			return model;
		},
	},
	methods: {
		trimmed(txt) {
			if(txt) {
				if(txt.length > 24) {
					return txt.substr(0, 17) + '...' +  txt.substr(txt.length - 4, 4);
				}
				return txt
			}
			return '';
		},
		deleteImage(image) {
			if(this.message.images.length > 1) {
				this.$emit('deleteImage', image, this.message)
			}
			else {
				if(this.message.content || this.message.attachments.length) {
					this.$emit('deleteImage', image, this.message)
				}
				else {
					this.$emit('startDelete', this.message)
				}
			}
		},
		deleteAttachment(attachment) {

			if(this.message.attachments.length > 1) {
				this.$emit('deleteAttachment', attachment, this.message)
			}
			else {
				if(this.message.content || this.message.images.length) {
					this.$emit('deleteAttachment', attachment, this.message)
				}
				else {
					this.$emit('startDelete', this.message)
				}


			}

		},
		previewImage(image) {
			this.$emit('previewImage', image);
		},
		getUserReactionTextAndColor(name) {
			switch (name) {
				case 'applause':
					return {
						color: 'blue--text',
						text: 'Polecasz',
						icon: '$applause-reaction',
					}
				case "happy":
					return {
						color: 'gold--text',
						text: 'Polecasz',
						icon: '$face-reaction',
					}
				case "love":
					return {
						color: 'warning--text',
						text: 'Polecasz',
						icon: '$heart-reaction',
					}
				default:
					return {
						color: 'success--text',
						text: 'Polecasz',
						icon: '$like-small',
					}
			}
		},
		getReactionText() {
			if(this.message && this.message.my_reaction) {
				return this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reacted.' + this.message.my_reaction.type)
			}
			return this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.reaction')
		},
		async react() {
			if (!this.message.my_reaction) {
				this.$refs['message-reaction-buttons'].submitReaction('like')
			}
			else {
				this.$refs['message-reaction-buttons'].submitReaction(this.message.my_reaction.type)
			}
		},
		async save() {
			this.saving = true;
			let res = await this.$store.dispatch('chat/editMessage', {
				id: this.message.id,
				data: this.finalModel
			});

			if(res.success) {
				this.$snackbar.success(this.$vuetify.lang.t('$vuetify.views.chat.messages.successfullyEdited'));
				this.edit = false;
			}
			else {
				this.$snackbar.error({error: res.error});
			}

			this.saving = false;
		},
		async delete() {
			this.deleting = true;
			await this.$store.dispatch('chat/deleteMessage', {
				id: this.message.id,
				chat_room_id: this.message.chat_room_id
			});
			this.deleting = false;
		},
		escapePress() {
			console.log("ESCAPED!")
		},
		startEdit() {
			this.edit = true;
			let m = [];
			this.message.mention_users.forEach(x => {
				m.push(x.id)
			})
			this.fields.content = {
				content: this.message.content,
				mentions: m,
				mention_users: this.message.mention_users
			};
			this.inputKey++;
		},
		onInput() {
			//
		},
		intersect(entries, observer, isIntersecting) {
			this.$emit('intersected', this.message.id, isIntersecting)
		},
		isReadByUser(id) {
			if(this.message.delivery_statuses) {
				let r = this.message.delivery_statuses.find(x => x.recipient_user_id == id);
				if(r && r.read_at) {
					return this.$moment(r.read_at).local().format('YYYY-MM-DD HH:MM:SS');
				}
			}

			return false;
		},

		getUser(id) {
			return this.users.find(x => x.id == id);
		}
	},
	created() {

	}
}
</script>

<style lang="scss">
	.chat__message {
		.chat-message-image {
			position: relative;

			.actions {
				position: absolute;
				display: none;
				top: 5px;
				right: 5px;
				z-index: 1;
			}
			&:hover {
				.actions {
					display: block;
				}
			}
		}
		.avatar-wrapper {
			width: 40px;
			min-width: 40px;
			max-width: 40px;
		}
		.message-body-container {
			min-width: calc(100% - 74px);
			width: 100%;
		}
		.chat-image-actions {
			position: absolute;
			bottom: 10px;
			left: 10px;
		}
		.message-action-container {
			position: absolute;
			top: 5px;
			right: 5px;
		}
		.edited-container {
			position: absolute;
			top: 2px;
			left: 12px;
			font-size: 10px;
			color: var(--v-grey-base);
		}
		.timestamp {
			color: var(--v-grey-base);
		}

		.message-body {
			border-top-right-radius: 8px;
			border-bottom-right-radius: 8px;
			border-bottom-left-radius: 8px;
			padding: 12px;
			position: relative;
			min-height: 40px
		}

		.delivery-status {
			padding-top: 3px;
			font-size: 12px;
			text-align: right;
		}
	}
	.chat__incoming-message {
		display: flex;
		flex-direction: row;
		width: 100%;
		max-width: 100%;

		.message-body {
			background: var(--v-grey-lighten2);
		}
	}
	.chat__outgoing-message {
		display: flex;
		flex-direction: row;

		.message-body {
			background: var(--v-accent-lighten2);
		}
	}
</style>
